import { chakraChakra } from "@airhelp/react-ui-components";
import axios from "axios";
import { Container } from "components";
import { FormError, FormSubmitButton } from "components/FormControl";
import { RichtextAdapter } from "modules/storyblok/adapters";
import { contentStyles } from "modules/storyblok/adapters/Content";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import type { SbEditableComponentProps } from "types/storyblok";
import type { UnsubscribeProps } from "./Unsubscribe.d";

const Form = chakraChakra("form");

export const Unsubscribe = ({
  confirmationMessage,
  ctaText,
  successMessage,
  errorMessage,
}: SbEditableComponentProps<UnsubscribeProps>) => {
  const [isError, setIsError] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);
  const {
    handleSubmit,
    formState: { isSubmitting, isSubmitSuccessful },
  } = useForm();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setUserId(urlParams.get("userId"));
  }, []);

  const onSubmit = async () => {
    try {
      const payload = {
        userId,
      };
      await axios.post("/api/iterable/unsubscribe/", payload);
    } catch (err) {
      setIsError(true);
    }
  };

  return (
    <Container px={{ base: 4, md: 10, lg: 40 }} my={8}>
      {!isSubmitSuccessful && (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <RichtextAdapter content={confirmationMessage} customStyles={contentStyles} />
          <FormSubmitButton
            isLoading={isSubmitting}
            isDisabled={!userId}
            type="submit"
            text={ctaText}
            w="unset"
            borderRadius="md"
          />
        </Form>
      )}
      {isSubmitSuccessful && !isError && <RichtextAdapter content={successMessage} customStyles={contentStyles} />}
      {isError && <FormError formErrorText={errorMessage} formError={isError} id="form-error" />}
    </Container>
  );
};
